import { Injectable } from '@angular/core';
import { ResetFormData } from '../../pages/auth/reset-password2/reset-password2.component';

@Injectable({
    providedIn: 'root',
})
export class PasswordService {
    private readonly minimumLength = 8;
    private readonly maximumLength = 50;
    private readonly minimumScore = 2;

    constructor() {}

    scoreAcceptable(formdata: ResetFormData): boolean {
        return this.charactersAcceptable(formdata) && formdata.passwordStrength >= this.minimumScore;
    }

    lengthAcceptable(formdata: ResetFormData): boolean {
        // @ts-ignore TS2322
        return formdata.password && formdata.password.length >= this.minimumLength && formdata.password.length <= this.maximumLength;
    }

    charactersAcceptable(formdata: ResetFormData): boolean {
        // Minimum eight characters,
        // at least one uppercase letter,
        // one lowercase letter and one number,
        // optional special characters
        // maximum 50 characters
        return this.lengthAcceptable(formdata) && /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d$@$!%*?&]{8,50}/.test(formdata.password);
    }

    passwordsMatch(formdata: ResetFormData): boolean {
        // @ts-ignore TS2322
        return formdata.password && formdata.confirmPswd && formdata.password === formdata.confirmPswd;
    }

    getLengthMinimum(): number {
        return this.minimumLength;
    }

    getLengthMaximum(): number {
        return this.maximumLength;
    }

    getScoreMinimum(): number {
        return this.minimumScore;
    }
}
